import { Component, EventEmitter, Input, Output, OnInit, DoCheck } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Subscription } from 'rxjs/internal/Subscription';

import { timer } from 'rxjs';
import { Message } from '../../models/message.model';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html'
})
export class ToastComponent implements OnInit, DoCheck {

  public _messages: Array<Message>;
  @Input()
  get messages(): Array<Message> {
    return this._messages;
  }
  set messages(value: Array<Message>) {
    this._messages = value;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this._messages && this._messages.length > 0) {
      this.setTimer();
    }
  }

  @Output() closed = new EventEmitter<boolean>();

  public toRemove: number;
  public closeAnimation: boolean = false;

  private subscription: Subscription;
  private timer: Observable<any>;

  constructor() {
  }

  ngOnInit() {
    //this.setTimer();
  }

  ngDoCheck(): void {
    if (this._messages.length > 1) {
      this._messages.some((message, index) => {
        if (message.class === 'error') {
          if (!(index-1 < 0)) {
            if (message.message === this._messages[index - 1].message) {
              this._messages.splice(index, 1);
            }
          }
        }
      });
    }
  }

  public async close() {
    this.closeAnimation = true;
    await this.sleep(300);
    this._messages.splice(this.toRemove, 1);
    this.toRemove = -1;
    if (this._messages.length === 0) {
      if (this.subscription) this.subscription.unsubscribe();
      this.closed.emit(false);
    }
  }

  private sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public setTimer() {
    this.timer = timer(5000); // 5000 millisecond means 5 seconds
    this.subscription = this.timer.subscribe(() => {
      this.close();

      if (this._messages.length !== 0) {
        this.setTimer();
      }
    });
  }

  public transformMessage(messageOriginal) {
    let message = '';

    if (typeof messageOriginal === 'string') {
      message = messageOriginal;
    } else {
      messageOriginal.forEach(error => {
        message = message + '<span>' + error + '</span>';
      });
    }

    return message;
  }

}
